import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const coapplicantPersonalSectionComponent = {
  editLink: 'coapplicant-personal-section.edit-link',
  email: 'coapplicant-personal-section.email',
  firstName: 'coapplicant-personal-section.first-name',
  h3: 'coapplicant-personal-section.h3',
  lastName: 'coapplicant-personal-section.last-name',
  phoneNumber: 'coapplicant-personal-section.phone-number',
  root: 'coapplicant-personal-section.root',
} as const satisfies ComponentLocatorMap;
